import { KnowledgeFrame } from '../components/KnowledgeNav'
import { GardenDashboard } from '../components/GardenDashboard'

export function OperationsPage() {
  return (
    <KnowledgeFrame
      title="Operations & resolutions"
      description="Follow the daily pipeline and drill into accepted decisions, reasoning and application state."
    >
      <GardenDashboard />
    </KnowledgeFrame>
  )
}
